import React, { useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";
const App = () => {
  useEffect(() => {
    const handleCopy = (e: ClipboardEvent) => e.preventDefault();
    document.addEventListener("copy", handleCopy);
    return () => {
      document.removeEventListener("copy", handleCopy);
    };
  }, []);
  return <AppRoutes />;
};
export default App;
